import React from 'react';
import { ListGroup } from 'react-bootstrap';
import HeaderSearchSitemap from './HeaderSearchSitemap';

const NavLeft = () => {
    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav mr-auto align-items-center">
                <ListGroup.Item as="li" bsPrefix=" " className="nav-item">
                    <HeaderSearchSitemap />
                </ListGroup.Item>
            </ListGroup>
        </React.Fragment>
    );
};

export default NavLeft;
